import { ProductForm } from '@/dto/responseDto/local-file.dto';
import httpAdmin from '@/httpCommon/axiosClient';
class ProductService {
    create = (body: ProductForm) => {
        return httpAdmin.post('dich_vu/san_pham', setParams(body));
    };
    importCSV = (file: File) => {
        const formData = new FormData();
        formData.append('file', file);
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        return httpAdmin.post('item/upload-single-file', formData, config);
    };
    getAll = async (params?: any) => {
        const res = await httpAdmin.get('dich_vu/san_pham', { params });
        return res?.data;
    };
    findById = async (id: string) => {
        const res = await httpAdmin.get(`dich_vu/san_pham/${id}`);
        return res.data;
    };
    update = async (id: string, body: ProductForm) => {
        const res = await httpAdmin.put(`dich_vu/san_pham/${id}`, setParams(body));
        return res.data;
    };
    updateBulk = async (body: ProductForm[]) => {
        const res = await httpAdmin.put(`dich_vu/san_pham`, body);
        return res.data;
    };
    delete = async (id: string) => {
        const res = await httpAdmin.delete(`dich_vu/san_pham/${id}`);
        return res.data;
    };
}

const setParams = (body: ProductForm) => ({
    category: body.categoryId,
    name: body.name,
    salesPrice: body.salesPrice,
    image: body.image,
});
export default new ProductService();
